import type {
  DeployResponse,
  DeployProgressEvent,
} from '@/app/shared/types/models/deploy.interface';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import deployService from './deploy-service';

export const useDeployStore = defineStore('deploy', () => {
  const isLoading = ref(false);
  const error = ref<string | null>(null);

  async function upload(
    file: File,
    onProgress?: (_event: DeployProgressEvent) => void
  ): Promise<DeployResponse> {
    isLoading.value = true;
    error.value = null;

    try {
      const request = {
        deploymentFile: file,
      };
      const uploadResponse = await deployService.upload(request, onProgress);
      return uploadResponse;
    } catch (err) {
      error.value = (err as Error).message;
      throw err;
    } finally {
      isLoading.value = false;
    }
  }
  return {
    upload,
    isLoading,
    error,
  };
});
